import AuditLogList from './AuditLogList'
import FactCheckIcon from '@mui/icons-material/FactCheck'

export default {
  list: AuditLogList,
  icon: FactCheckIcon,
}
